import React from "react";
import { fetchApi } from "../../Utils/Connections";
import { connect } from "react-redux";

import AdminModal from "../../components/AdminModal/AdminModal";

const mapStateToProps = (state: any) => {
  return {
    adminModal: state.AdminModal,
    selectedMember: state.selectedMember,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    setAdminModal: (AdminModal: boolean) =>
      dispatch({ type: "SET_ADMIN_MODAL", payload: AdminModal }),
    setSelectedMember: (selectedMember: any) =>
      dispatch({ type: "SET_SELECTED_MEMBER", payload: selectedMember }),
  };
};

const Dashboard = ({ adminModal, setAdminModal, setSelectedMember }: any) => {
  const [members, setMembers] = React.useState<any[]>([]);

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string>("");
  const [mode, setMode] = React.useState("add");

  React.useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    setError("");
    try {
      const result = await fetchApi(`Admin/GetMembers`, "GET", {});
      if (result.StatusCode === 200 && Array.isArray(result.My_Result)) {
        setMembers(result.My_Result);
      } else {
        console.warn("GetMembers rejected", result?.StatusCode, result?.ExceptionMsg);
        setError("Could not load members.");
      }
    } catch (e) {
      console.warn("GetMembers failed", e);
      setError("Could not reach the server. Check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminDashboard">
      <div className="adminNavbar d-flex justify-content-between align-items-center px-3">
        <img src="/assets/images/lweb.png" alt="ICDR" height="56" className="py-2" />
        <button
          className="btn btn-outline-light btn-sm rounded"
          onClick={() => {
            sessionStorage.removeItem("token");
            window.location.reload();
          }}>
          <i className="bi bi-box-arrow-right mr-1" /> Log out
        </button>
      </div>

      <div className="container adminContent">
        <div className="adminHeader d-flex flex-wrap justify-content-between align-items-center mb-4">
          <div>
            <h1 className="adminTitle mb-0">Members</h1>
            {!error && (
              <span className="text-muted">
                {loading ? "Loading…" : `${members.length} registered`}
              </span>
            )}
          </div>
          <button
            className="btn btn-primary rounded"
            onClick={() => {
              setMode("add");
              setAdminModal(true);
            }}>
            <i className="bi bi-plus-lg mr-1" /> Add Member
          </button>
        </div>

        {error && (
          <div className="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
            <span>{error}</span>
            <button className="btn btn-sm btn-outline-danger rounded" onClick={getData}>
              Retry
            </button>
          </div>
        )}

        {!loading && !error && members.length === 0 && (
          <div className="adminEmpty text-center text-muted">
            <i className="bi bi-people d-block mb-2" />
            No members yet. Use “Add Member” to create the first one.
          </div>
        )}

        <div className="row">
          {!loading &&
            members.map((item: any) => (
              <div className="col-xl-4 col-md-6 col-12 mb-4" key={item.IdUser}>
                <div className="memberCard h-100 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h2 className="memberName">{item.FullName}</h2>
                    <span className="memberCode">#{item.Code}</span>
                  </div>
                  <p className="memberPosition flex-grow-1">{item.Position}</p>
                  <div className="d-flex justify-content-between align-items-center memberFooter">
                    <small className="text-muted">
                      Added {new Date(item.DateCreated).toLocaleDateString()}
                    </small>
                    <button
                      className="btn btn-sm btn-link memberEdit p-0"
                      onClick={() => {
                        setMode("edit");
                        setSelectedMember(item);
                        setAdminModal(true);
                      }}>
                      <i className="bi bi-pencil-square mr-1" /> Edit
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <AdminModal mode={mode} />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
